import asyncActionCreator from '@/utils/asyncActionCreator';
import { getUserInfoAPI, modifySubjectAPI, exitLoginAPI, setCateitemListAPI } from '@/API'

export const PATH_CHANGE = 'Url has changed';
export const changePath = (path) => ({
    type: PATH_CHANGE,
    payload: path
});

// 改变数据状态
export const EDIT_PARAM_STATUS = 'change param status';
export const editParam = data => {
	return {
		type: EDIT_PARAM_STATUS,
		payload: data
	}
}

// 获取用户信息
export const GET_USER_SUCCESS = 'Get user info success';
const getUserInfoAsyncSuccess = (data, product) => {
    return {
        type: GET_USER_SUCCESS,
        payload: { data, product },
    }
}
export const getUserInfo = (params, sucCallback, errCallback) => {
	return (dispatch) => {
		getUserInfoAPI(params).then(res => {
			dispatch(getUserInfoAsyncSuccess(res.data, res.product));
			sucCallback && sucCallback();
		}, (err) => {
			errCallback && errCallback(err)
		});
	}
}

// 推出登陆
export const EXITLOGIN = 'exit login';
const exitLoginSuccess = (data) => {
    return {
        type: EXITLOGIN,
        payload: data,
    }
}
export const exitLogin = (params, sucCallback, errCallback) => {
	return (dispatch) => {
		exitLoginAPI(params).then(res => {
			dispatch(exitLoginSuccess(res.data));
			sucCallback && sucCallback();
		}, (err) => {
			errCallback && errCallback(err)
		});
	}
}

// 修改学科学段
export const MODIFY_SUBJECT_INFO = 'modify subject info';
const modifySubjectSuccess = (result) => {
	return {
		type: MODIFY_SUBJECT_INFO,
		payload: result
	}
}
export const modifySubjectInfo = (params, sucCallback, errCallback) => {
	return (dispatch) => {
		modifySubjectAPI(params).then(res => {
			dispatch(modifySubjectSuccess(res.data));
			sucCallback && sucCallback();
		}, (err) => {
			errCallback && errCallback(err)
		});
	}
}

// 会认生字，会写生字
export const SET_CATEITEM_INFO = 'question message - set cateitem list';
const setCateitemSuccess = (result) => {
	return {
		type: SET_CATEITEM_INFO,
		payload: result
	}
}
export const setCateitemList = (params, sucCallback, errCallback) => {
	return (dispatch) => {
		setCateitemListAPI(params).then(res => {
			dispatch(setCateitemSuccess(res.data));
			sucCallback && sucCallback();
		}, (err) => {
			errCallback && errCallback(err)
		});
	}
}




// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_tml/action.js